import { Slot } from '@farol-ds/react'
import classNames from 'classnames'
import { HTMLAttributes, isValidElement } from 'react'

import styles from './list-block.module.scss'

export type ListBlockContentElement = HTMLDivElement

export type ListBlockContentProps = HTMLAttributes<ListBlockContentElement> & {
  asChild?: boolean
}

function ListBlockContent(props: ListBlockContentProps) {
  const { children, className, asChild: asChildProp, ...rest } = props

  const asChild = asChildProp && isValidElement(children)
  const Component = asChild ? Slot : 'div'
  const isClickable = asChild && ['a', 'button'].includes(children?.type as string)

  const classes = classNames(
    styles.content,
    {
      [styles.clickable]: isClickable,
    },
    className
  )

  return (
    <Component className={classes} {...rest}>
      {children}
    </Component>
  )
}

export default ListBlockContent
